import React, { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Typography, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Copyright from "../components/Copyright";
import { useTranslation } from "react-i18next";
import FarmAppLogo from "../assets/logo/FarmAppLogo.png";
import PasswordVisibility from "../components/PasswordVisibility";
import { SERVER_BASE_ADDRESS } from "../globals/const";
import api from "../globals/axios";
import { useAlert } from "../components/Alert";

const UpdatePassword = () => {
  const [password, setPassword] = useState("");
  const [newpassword, setnewPassword] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  function updatepassword(event) {
    setLoading(true);
    event.preventDefault();

    if (!password || !newpassword) {
      showAlert("error", "Enter details");
      setLoading(false);
      return;
    }
    api
      .post(`${SERVER_BASE_ADDRESS}/auth/update-password/`, {
        password: password,
        newpassword: newpassword,
      })
      .then((result) => {
        if (result && result.data) {
          setLoading(false);
          if (result.data.status === "SUCCESS") {
            showAlert("success", "Password Updated Successfully");
            navigate("/login");
          } else {
            let message = `Error - ${result.data.message}`;
            showAlert("error", message);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        let message = "Error - An unexpected error occurred";
        if (err.response) {
          if (err.response.data && err.response.data.non_field_errors) {
            message = `Error - ${err.response.data.non_field_errors[0]}`;
          } else if (err.response.data && err.response.data.message) {
            message = `Error - ${err.response.data.message}`;
          }
          showAlert("error", message);
        }
      });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div
        style={{
          display: "flex",
          padding: "20px",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          alt="farmapp"
          src={FarmAppLogo}
          style={{ width: "206", height: "188px" }}
        />
        <form
          style={{
            width: "100%",
            marginTop: 50,
          }}
          noValidate
          onSubmit={updatepassword}
        >
          <Typography variant="h6" align="center" mb={2}>
            {t("Update Password to FarmApp")}
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="oldpassword"
            label={t("Old Password")}
            name="oldpassword"
            type={showPassword ? "text" : "password"}
            autoFocus
            InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              ),
            }}
            onChange={(event) => setPassword(event.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="newpassword"
            label={t("New Password")}
            type={showPassword ? "text" : "password"}
            id="newpassword"
            InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              ),
            }}
            onChange={(event) => setnewPassword(event.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2, color: "white" }}
          >
            {loading ? (
              <CircularProgress size={28} style={{ color: "white" }} />
            ) : (
              t("Submit")
            )}{" "}
          </Button>
        </form>
      </div>
      <Box mt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default UpdatePassword;
